import axios from "axios";
import api from "../../services/api";
import { API_BASE } from "../../config/env";
import { CHECKOUT_BASE } from "../../config/env";
import Swal from "sweetalert2";
export const FETCH_CARTUPDATE_FULFILLED = "FETCH_CARTUPDATE_FULFILLED";
export const FETCH_CARTUPDATE_REJECTED = "FETCH_CARTUPDATE_REJECTED";
export const FETCH_CARTUPDATE_PENDING = "FETCH_CARTUPDATE_PENDING";
export const RESET_CARTUPDATE = "RESET_CARTUPDATE";


export function cartUpdate(currentStateHandle, deliveryProviderId, invoiceAddressId, couponCodes) {
    return (dispatch) => {
      return new Promise((resolve, reject) => {
        dispatch({ type: FETCH_CARTUPDATE_PENDING });
  
        api
          .post("/gate/cart/update", { currentStateHandle, deliveryProviderId, invoiceAddressId, couponCodes })
          .then((response) => {
            dispatch({
              type: FETCH_CARTUPDATE_FULFILLED,
              payload: response.data?.data,
            });
            resolve(response.data?.data); // Başarılı sonuç döndürülür
          })
          .catch((error) => {
            dispatch({
              type: FETCH_CARTUPDATE_REJECTED,
              payload: error,
            });
            reject(error); // Hata fırlatılır
          });
      });
    };
  }
  


export function resetCartUpdate() {
    return (dispatch) => {
        dispatch({
            type: RESET_CARTUPDATE,
        });
    };
}